import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Resizer from "react-image-file-resizer";
import Select from "react-select";
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../components/CustomComponent.js";
import BRANCH from "../../assets/images/branch.png";
import "../../components/global.js";
import "../../assets/css/bootstrap.css";
export default class Console extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_create: false,
            modal_update: false,
            modal_delete: false,
            modal_logout: false,

            search: "",
            loading: false,

            data: [],

            branch_id: "",
            branch_name: "",
            tax_number: "",
            prefix: "",
            address: "",
            phone_number: "",
            email: "",
            picture: "",
        }
        this.picture_branch = React.createRef();
    }
    async componentDidMount() {
        let user = getStorage("user") ? getStorage("user") : null;
        if (user && user.branch_id) {
            window.location.href = "/dashboard"
        }
        await this.GetbranchAll();
    }
    GetbranchAll = async () => {
        this.setState({ loading: true });
        let body = {
            data_search: "",
            branch_id: "",
            page: 0
        }
        let result = await GET(tokens, "v1/TH/branch/list", body);
        if (result && result.status) {
            this.setState({ data: result.data })
        }
        this.setState({ loading: false });
    }
    Create = async () => {
        if (validate(this.state, ["branch_name"])) { return };
        this.setState({ loading: true });
        let body = {
            branch_name: this.state.branch_name,
            tax_number: this.state.tax_number,
            prefix: this.state.prefix,
            address: this.state.address,
            phone_number: this.state.phone_number,
            email: this.state.email,
            picture: this.state.picture,
        }
        let result = await POST(tokens, "v1/TH/branch/create", body);
        if (result && result.status) {
            success_url("/console");
        }
        this.setState({ loading: false });
    }
    Update = async () => {
        if (validate(this.state, ["branch_name"])) { return };
        this.setState({ loading: true });
        let body = {
            branch_id: this.state.branch_id,
            branch_name: this.state.branch_name,
            tax_number: this.state.tax_number,
            prefix: this.state.prefix,
            address: this.state.address,
            phone_number: this.state.phone_number,
            email: this.state.email,
            picture: this.state.picture,
        }
        let result = await PUT(tokens, "v1/TH/branch/update", body);
        if (result && result.status) {
            success_url("/console");
        }
        this.setState({ loading: false });
    }
    Delete = async () => {
        this.setState({ loading: true });
        let result = await DELETE(tokens, "v1/TH/branch/delete/" + this.state.branch_id, null);
        if (result && result.status) {
            success_url("/console");
        }
        this.setState({ loading: false });
    }
    import_file = (e) => {
        this.changePhoto(e.target.files[0])
        document.getElementById("file").value = "";
        document.getElementById("file").file = null;
    }
    changePhoto = async (file) => {
         
        if (!file.type.includes("image")) {
            alert("error", "แจ้งเตือน", "ไม่สามารถอัพโหลดไฟล์ได้เนื่องจากไม่รองรับรูปแบบไฟล์");
            return
        }
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (e) => { }
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file, 512, 512, "JPG", 100, 0,
                (uri) => {
                    this.setState({ picture: uri.split(",")[1] })
                },
                "base64"
            );
        });
    }
    clear_form() {
        this.setState({
            modal_create: false,
            modal_update: false,
            modal_delete: false,

            search: "",
            loading: false,

            branch_id: "",
            branch_name: "",
            tax_number: "",
            prefix: "",
            address: "",
            phone_number: "",
            picture: "",
        })
    }
    render() {
        return (
            <div className="w-100 min-vh-100 background-console">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <div className="w-100 min-vh-100">
                    {/* สวัสดี วิเชียร มาลาคำ เลือกสาขาที่ต้องการ */}
                    <div className="w-100 pt-5 pb-3">
                        <div className="container text-center">
                            <h2><b>สวัสดี</b> <b className="text-orange">{getStorage("user") ? getStorage("user").full_name : "-"}</b></h2>
                            <h1><b>เลือกสาขาที่ต้องการ</b></h1>
                        </div>
                    </div>
                    {/* สาขา */}
                    <div className="w-100 py-4">
                        <div className="container">
                            <div className="d-flex justify-content-between mb-5 flex-wrap">
                                <input
                                    className="form-control bg-white border-0 shadow-sm wpx-250 mb-2"
                                    type="search"
                                    placeholder="ชื่อกิจการ..."
                                    onChange={(e) => { this.setState({ search: e.target.value }) }}
                                    value={this.state.search}
                                />
                                <div className="d-flex align-items-center">
                                    <button className="btn btn-orange px-5"
                                        onClick={() => {
                                            this.clear_form();
                                            setTimeout(() => {
                                                this.setState({ modal_create: true });
                                            }, 10);
                                        }}>เพิ่มสาขาใหม่</button>
                                    <label className="icon text-18 p-2 text-danger pointer ms-3" onClick={() => { this.setState({ modal_logout: true }) }}>{"\uf2f5"}</label>
                                </div>
                            </div>
                            <div className="row">
                                {this.state.data.filter(item => JSON.stringify(item).includes(this.state.search) || this.state.search === "").map((item, index) => (
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-2" key={index}>
                                        <div className="card w-100 p-3 border-0 rounded-lg align-items-center pointer hover"
                                            onClick={() => {
                                                setTimeout(() => {
                                                    if (!this.state.modal_delete && !this.state.modal_update) {
                                                        localStorage.setItem("branch", JSON.stringify(item))
                                                        window.location.href = "/dashboard"
                                                    }
                                                }, 10);
                                            }}
                                        >
                                            <img className="mt-4 mb-2 wpx-150 hpx-150 rounded-circle" src={item.picture ? item.picture : BRANCH} alt="สาขา" style={{ objectFit: "cover" }} />
                                            <h5>สาขาที่ {index + 1} {item.branch_name ? item.branch_name : "-"}</h5>
                                            <span className="bg-orange px-3 py-1 rounded text-white mb-2">Free Account</span>
                                            <label>หมายเลขผู้เสียภาษี {item.tax_number ? item.tax_number : "-"}</label>
                                            <div className="d-flex position-absolute" style={{ right: 6, top: 6 }}>
                                                <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                    onClick={() => {
                                                        this.setState({
                                                            modal_update: true,
                                                            branch_id: item.branch_id,
                                                            branch_name: item.branch_name,
                                                            prefix: item.prefix,
                                                            tax_number: item.tax_number,
                                                            address: item.address,
                                                            phone_number: item.phone_number,
                                                            email: item.email,
                                                            picture: item.picture ? item.picture : "",
                                                        })
                                                    }}>
                                                    <label className="pointer icon text-primary p-2">{"\uf044"}</label>
                                                </div>
                                                <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                    onClick={() => {
                                                        this.setState({
                                                            modal_delete: true,
                                                            branch_id: item.branch_id,
                                                            branch_name: item.branch_name,
                                                        })
                                                    }}>
                                                    <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                {/* create update */}
                <Modal show={this.state.modal_create || this.state.modal_update}
                    onHide={() => { this.setState({ modal_create: false, modal_update: false }) }}>
                    <Modal.Header><Modal.Title><b>{this.state.modal_create ? "เพิ่มสาขา" : "แก้ไขรายละเอียดสาขา"}</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        {/* รูปสาขา */}
                        <div className="w-100 mb-2">
                            {this.state.picture === "" ? (
                                <div
                                    className="w-100 pointer card d-flex align-items-center justify-content-center px-3 py-5 bg-light rounded hpx-200"
                                    onClick={() => { document.getElementById("file").click() }}
                                >
                                    <label className="icon text-secondary pointer">{"\uf0ee"}</label>
                                    <label className="text-secondary pointer">อัปโหลดรูปภาพ</label>
                                </div>
                            ) : (
                                <div className="w-100 card border-2 border-orange d-flex align-items-center justify-content-center p-2  mb-2">
                                    <div className="position-relative w-100">
                                        <img alt="รูปสาขา" src={this.state.picture.includes("https://") ? this.state.picture : "data:image/png;base64," + this.state.picture} className="w-100 rounded overflow-hidden" style={{ maxHeight: 250, objectFit: "contain" }}></img>
                                        <div className="icon pointer bg-danger text-white position-absolute wpx-30 hpx-30 d-flex justify-content-center align-items-center rounded-circle" style={{ top: -8, right: -8 }} onClick={() => { this.setState({ picture: "" }) }}>
                                            {"\uf00d"}
                                        </div>
                                    </div>
                                </div>
                            )}
                            <input className="d-none" type="file" id="file" accept="image/*" onChange={(e) => { this.import_file(e, "main") }} />
                        </div>
                        <hr />
                        <div className="row">
                            {/* ชื่อสาขา */}
                            <div className="col-12 col-md-4 mb-2">
                                <label className="mb-2">ชื่อสาขา:</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ branch_name: e.target.value }) }}
                                    value={this.state.branch_name}
                                />
                            </div>
                            {/* เลขที่ผู้เสียภาษี */}
                            <div className="col-12 col-md-4 mb-2">
                                <label className="mb-2">เลขที่ผู้เสียภาษี:</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ tax_number: e.target.value }) }}
                                    value={this.state.tax_number}
                                />
                            </div>
                            {/* Prefix */}
                            <div className="col-12 col-md-4 mb-2">
                                <label className="mb-2">Prefix</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ prefix: e.target.value }) }}
                                    value={this.state.prefix}
                                />
                            </div>
                            {/* ที่อยู่ */}
                            <div className="col-12 mb-2">
                                <label className="mb-2">ที่อยู่:</label>
                                <textarea
                                    className="form-control"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ address: e.target.value }) }}
                                    value={this.state.address}
                                    rows={3}
                                ></textarea>
                            </div>
                            {/* เบอร์โทร */}
                            <div className="col-12 col-md-6 mb-2">
                                <label className="mb-2">เบอร์โทร:</label>
                                <input
                                    className="form-control"
                                    type="tel"
                                    maxLength={10}
                                    placeholder=""
                                    onChange={(e) => {
                                        if (!float(e.target.value)) {
                                            return
                                        }
                                        this.setState({ phone_number: e.target.value })
                                    }}
                                    value={this.state.phone_number}
                                />
                            </div>
                            {/* Email */}
                            <div className="col-12 col-md-6 mb-2">
                                <label className="mb-2">Email:</label>
                                <input
                                    className="form-control"
                                    type="email"
                                    placeholder=""
                                    onChange={(e) => {
                                        this.setState({ email: e.target.value })
                                    }}
                                    value={this.state.email}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ modal_create: false, modal_update: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-orange w-100"
                                    onClick={() => {
                                        if (this.state.modal_create) {
                                            this.Create();
                                        } else {
                                            this.Update();
                                        }
                                    }}>
                                    {this.state.modal_create ? "เพิ่ม" : "บันทึก"}
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* delete */}
                <Modal show={this.state.modal_delete} onHide={() => { this.setState({ modal_delete: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ลบสาขา</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <label>
                            ท่านต้องการลบสาขา “{this.state.branch_name}”
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <label className="mb-2 w-100">
                            หมายเหตุ ไม่สามารถกู้คืนได้
                        </label>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.Delete() }}>
                                    ลบ
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_delete: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>

                {/* MODAL */}
                <Modal show={this.state.modal_logout} onHide={() => { this.setState({ modal_logout: false }) }}>
                    <Modal.Header><Modal.Title><b>ออกจากระบบ</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        <div className="w-100  mb-2">
                            <label>ยืนยันการออกจากระบบหรือไม่</label>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ modal_logout: false }) }}>ยกเลิก</button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-orange w-100" onClick={() => { logout() }}>ออกจากระบบ</button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
